// @module C3.ShoppingExtensions.MeetTeam
define('C3.ShoppingExtensions.NewsletterSignup.AutomaticSuccess.View'
,	[
	'c3_shoppingextensions_newslettersignup_automaticsuccess.tpl'
	
	
	,   'Utils'
    ]
, function (
	c3_shoppingextensions_meetteam_tpl
	
	
	,   Utils
)
{
    'use strict';

	// @class C3.ShoppingExtensions.MeetTeam.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_meetteam_tpl

	,   attributes: {
	        id: 'newsletter-signup-success'
	    }	
	,	initialize: function (options) {
			this.options = options;
			this.application = options.application;
			
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return C3.ShoppingExtensions.MeetTeam.View.Context
	,	getContext: function getContext()
		{
			
			return {
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}
	});
});
